import { setTransactionsView } from "@actions";
import { mapToSelect } from "@api/egm";
import transactions from "@api/transactions";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Form, Input, Select } from "semantic-ui-react";

const TicketsFilters = (props) => {
  const { setTransactionsView } = props;
  const { filterTypes, filterValues, searchParams } = props.view;
  const { loading } = props.data;
  const { selectedFilterType, selectedFilterValue } = searchParams;
  const { hasSelection } = props.filters;
  const { operator } = props.filters.filterSelected;
  const siteId = props.filters.filterSelected.site.id;

  useEffect(() => {
    if (filterTypes.length > 0) {
      return;
    }
    transactions.getFilterTypes().then((filterTypes) => {
      const selectedFilterType =
        filterTypes.length > 0 ? filterTypes[0].id : null;
      setTransactionsView({
        filterTypes: mapToSelect(filterTypes),
        searchParams: { ...searchParams, selectedFilterType },
      });
    });
  }, [searchParams, setTransactionsView]);

  useEffect(() => {
    if (!selectedFilterType || !operator || !siteId) {
      return;
    }

    transactions
      .getFilterList(operator, siteId, selectedFilterType)
      .then((filterValues) =>
        setTransactionsView({
          filterValues: mapToSelect(filterValues, true),
          searchParams: { ...searchParams, selectedFilterValue: "-1" },
        }),
      );
  }, [selectedFilterType, operator, siteId]);

  const onChange = (e, { name, value }) => {
    setTransactionsView({ searchParams: { ...searchParams, [name]: value } });
  };

  const disabled = loading || !hasSelection;

  return (
    <Form>
      <Form.Group>
        <Form.Field style={{ width: "100px" }}>
          <Select
            name="selectedFilterType"
            fluid
            disabled={disabled}
            onChange={onChange}
            options={filterTypes}
            value={selectedFilterType}
          />
        </Form.Field>
        {filterValues.length > 0 && (
          <Form.Field width={6}>
            <Select
              search
              name="selectedFilterValue"
              onChange={onChange}
              fluid
              disabled={disabled}
              options={filterValues}
              value={selectedFilterValue}
            />
          </Form.Field>
        )}

        <Form.Field width={2}>
          <Input
            placeholder="Ticket Serial"
            name="ticketSerial"
            onChange={onChange}
            disabled={disabled}
          />
        </Form.Field>
      </Form.Group>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    filters: state.transactionsFilters,
    data: state.transactionsTickets,
    view: state.transactionsView,
  };
};

export default connect(mapStateToProps, { setTransactionsView })(
  TicketsFilters,
);
